import { render, staticRenderFns } from "./experimentdisplay.vue?vue&type=template&id=f1160cbc&scoped=true"
import script from "./experimentdisplay.vue?vue&type=script&lang=js"
export * from "./experimentdisplay.vue?vue&type=script&lang=js"
import style0 from "./experimentdisplay.vue?vue&type=style&index=0&id=f1160cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1160cbc",
  null
  
)

export default component.exports